import React, { useState } from "react";
import { Icon } from "@iconify/react";
import "./Style/calendar.css";

export default function ShortCalendar({ isEdit, setEdit }) {
  const [currentDate] = useState(new Date());

  function handleEdit() {
    setEdit(!isEdit);
  }

  const month = currentDate.toLocaleString("default", { month: "short" });
  const year = currentDate.getFullYear();
  const today = currentDate.getDate();
  const currentWeekStart = today - currentDate.getDay();
  const currentWeekEnd = currentWeekStart + 6;

  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const generateDays = () => {
    let days = [];
    let currentRow = [];
    const totalDays = new Date(year, currentDate.getMonth() + 1, 0).getDate();

    for (let day = 1; day <= totalDays; day++) {
      if (day >= currentWeekStart && day <= currentWeekEnd) {
        const isToday =
          day === today &&
          currentDate.getMonth() === new Date().getMonth() &&
          currentDate.getFullYear() === new Date().getFullYear();

        const dayElement = (
          <div key={day} className="date">
            {isToday ? <div className="today-circle">{day}</div> : day}
          </div>
        );

        currentRow.push(dayElement);

        if (currentRow.length === 7 || day === totalDays) {
          days.push(
            <div key={`row-${day}`} className="week">
              {currentRow}
            </div>
          );
          currentRow = [];
        }
      }
    }

    return days;
  };

  return (
    <div className="calendar">
      <div className="calendar-header">
        <span className="option">Progress</span>
        <span className="month-year short">
          {month} <span className="year">{year}</span>
        </span>
        <span onClick={handleEdit}>
          <Icon icon="fluent:edit-32-filled" className="edit" />
        </span>
      </div>
      <div className="calendar-body">
        <div className="days">
          {daysOfWeek.map((day) => (
            <div key={day} className="day">
              {day}
            </div>
          ))}
        </div>
        <div className="dates">{generateDays()}</div>
      </div>
    </div>
  );
}
